import { PositionDTO } from '@asd-stan/user/api/position/position.dto';
import { Position } from '@asd-stan/user/domain/position.entity';

export const makePositionFromPositionDTO = (dto: PositionDTO): Position => {
	return new Position({
		id: dto.id,
		name: dto.name,
	});
};
